var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_167118",
    "data-name": "Grupo 167118",
    transform: "translate(14758 1848)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_148482",
    "data-name": "Ret\\xE2ngulo 148482",
    width: 40,
    height: 40,
    transform: "translate(-14758 -1848)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_166796",
    "data-name": "Grupo 166796",
    transform: "translate(-14980.001 -2227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_166796-2",
    "data-name": "Grupo 166796"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9586",
    "data-name": "Elipse 9586",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(235.996 392.996)",
    fill: "none",
    stroke: "#73398d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83687",
    "data-name": "Caminho 83687",
    d: "M23,11v7.5a4.5,4.5,0,1,0,9,0V17a15,15,0,1,0-5.88,11.91",
    transform: "translate(225.002 382)",
    fill: "none",
    stroke: "#73398d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.4e7f0bb18fdc6239b198ff147aa8080c.svg";
export { ForwardRef as ReactComponent };